import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoCameraFrontIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_camera_front"}/>
}
